var yy_request = require('../js/yunyin_request');
var po = require('../js/public_object.js')

module.exports = {
  props: {
    show: {
      type: Boolean,
      required: true,
      twoWay: true,
    }
  },

  data: function () {
    return {
      modalWidth: 400,
      title: "请先登录云印",
      showCode: false,
      code: '',
      cookie: '',
      codeSrc: '',
      studentid: '',
      password: '',
      schoolid: 0,
      usertype: '',
      remeber: false,
      errorinfo: '',
      pwnew: '',
      showLogin: true,
      showReset: false,
      showDone: false,
      fromSchool: '',
      newUserName: '',
    }
  },

  computed: {
    title: function() {
      if(this.showLogin) {
        return "请登录云印"
      } else if(this.showReset) {
        return "设置您的云印密码"
      } else {
        return "注册完成"
      }
    }
  },

  methods: {
    onNumberChange: function(e) {
      var vuemodel = this
      var sch_value = []
      var sch_key = []

      yy_request.rest_api({
        method: 'post',
        api: 'school/number/',
        data: {
          number: vuemodel.studentid
        },
        opSuccess: function(info) {
          for(var key in info){
            sch_key.push(key)
            sch_value.push(info[key])
          }

          vuemodel.schoolid = sch_key[0]

          if(sch_value[0]==0) {
            vuemodel.usertype = 'old'
            vuemodel.errorinfo = ""
            vuemodel.showCode = false
          } else {
            vuemodel.usertype = 'new'
            vuemodel.errorinfo = ""
            refreshCode(vuemodel)
          }         
        },
        opFail: function(info) {
          vuemodel.usertype = 'wrong'
          vuemodel.errorinfo = "学号格式有误"
        }
      })
    },

    onSubmit: function(e) {
      var vuemodel = this
      if(vuemodel.usertype=='old') {
        oldUserLogin(vuemodel)
      } else if(vuemodel.usertype=='new') {
        newUserVerify(vuemodel)
      }
    },

    newPassword: function(e) {
      var md5 = require("blueimp-md5")
      var vuemodel = this

      yy_request.rest_api({
        method: 'post',
        api: 'user/',
        data: {
          password: md5(vuemodel.pwnew)
        },
        opSuccess: function(info) {
          loginSuccess(info.user)
          vuemodel.showDone  = true
          vuemodel.showReset = false        
        }
      })
    },

    noNewPassword: function(e) {
      var vuemodel = this
      yy_request.rest_api({
        method: 'post',
        api: 'user/',
        opSuccess: function(info) {
          loginSuccess(info.user)
          vuemodel.showDone  = true
          vuemodel.showReset = false        
        }
      })      
    },

    changeCode: function(e) {
      refreshCode(this)
    },

    afterLogin: function(e) {
      afterLogin(this)
    },

    onForgetPassword: function(e) {
      window.location.hash = "#/forget"
      po.app.showLoginModal = false
    },

  },

  components: {
    'modal': require('./modal.vue'),
  }
}

function oldUserLogin(vuemodel) {
  yy_request.rest_api({
    method: 'post',
    api: 'auth/',
    data: {
      number: vuemodel.studentid,
      password: vuemodel.password,
    },
    opSuccess: function(info) {
      loginSuccess(info.user)
      afterLogin(vuemodel)
      vuemodel.errorinfo = ""       
    },
    opFail: function(info) {
      vuemodel.errorinfo = info
    },
    authFail: function(info) {
      vuemodel.errorinfo = info
    }
  })
}

function refreshCode(vuemodel) {
  var refreshCodeAPI = 'school/' + vuemodel.schoolid + '/code/'

  yy_request.rest_api({
    method: 'get',
    api: refreshCodeAPI,
    opSuccess: function(info) {
      vuemodel.$$.verifycode.src = info.img
      vuemodel.cookie = info.verify_cookie
      vuemodel.showCode = true      
    },
    opFail: function(info) {
      vuemodel.showCode = false
    }
  })

}

function newUserVerify(vuemodel) {
  var ajax_data = {
    number: vuemodel.studentid,
    password: vuemodel.password,
    sch_id: vuemodel.schoolid,
  }

  if(vuemodel.showCode) {
    ajax_data.code = vuemodel.code
    ajax_data.verify_cookie = vuemodel.cookie
  }

  yy_request.rest_api({
    method: 'post',
    api: 'auth/',
    data: ajax_data,
    verifySuccess: function(info) {
      vuemodel.fromSchool = info.user.school
      vuemodel.newUserName = info.user.name
      vuemodel.showReset = true
      vuemodel.showLogin = false    
    },
    authFail: function(info) {
      vuemodel.errorinfo = "学校身份信息验证失败，请确认信息正确"
      if(vuemodel.showCode) {
        refreshCode(vuemodel)
      }     
    }
  })
}

function loginSuccess(user) {
  po.islogin = true
  po.userinfo = user
  po.app.username = user.name
}

function afterLogin(vuemodel) {

  vuemodel.show = false

  setTimeout(function(){
    vuemodel.showReset = false
    vuemodel.showLogin = true
    vuemodel.showDone = false
    vuemodel.showCode = false   

  },1000)

  // window.location.reload()

  // if(po.app.view=='intro-view') {
  //   window.location.hash = '#/menu'
  // }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/login-modal.vue
// module id = 140
// module chunks = 0